<template>
  <div class="container">
    <div class="header-left">
      <img src="@/assets/logo.svg" alt="Clue" class="logo">
    </div>
    <div class="header-center">
        <input type="text" id="search" name="search" placeholder="Search in Clue Concepts" :value="searchKeyword" @input="onSearchChange">
    </div>
    <div class="header-right">
      <button class="btn btn-hollow toggle-btn toggle-filters" :class="{ 'active': filtersActive }" @click="toggleFilters"><span>Filters</span><span class="count" :class="{ 'show_count': filtersCount > 0 }">{{ filtersCount }}</span></button>
      <button class="btn btn-hollow toggle-btn toggle-mode" @click="toggleDarkMode"></button>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/index";

const SEARCH_STORAGE_KEY = "clue.concepts.search";

export default {
  name: 'HeaderList',
  
  components: {},

  data() {
    return {
      debounceSearch: undefined,
      searchKeyword: "",
    };
  },

  computed: {
    filtersActive() {
      return this.$store.state.showFilters;
    },
    filtersCount() {
      return this.$store.getters["filtersCount"];
    }
  },

  methods: {
    loadSavedSearch() {
      return localStorage.getItem(SEARCH_STORAGE_KEY) || "";
    },
    toggleDarkMode() {
      $("#concepts-listing").toggleClass('darkmode');
      this.$store.dispatch("toggleDarkMode");
    },
    toggleFilters() {
      this.$store.dispatch("toggleFilters");
    },
    onSearchChange(e) {
      // console.log("onSearchChange", e.target.value);
      this.searchKeyword = e.target.value;
      localStorage.setItem(SEARCH_STORAGE_KEY, this.searchKeyword);
      this.debounceSearch(e.target.value);
    }
  },

  created() {
    this.searchKeyword = this.loadSavedSearch();
    this.$store.dispatch("changeSearch", this.searchKeyword);
    this.debounceSearch = utils.debounce((input) => {
      localStorage.setItem(SEARCH_STORAGE_KEY, input);
      this.$store.dispatch("changeSearch", input);
    }, 1000);
  },

  mounted() {
    if (this.$store.state.darkMode) {
      $("#concepts-listing").addClass('darkmode');
    }
  }
}
</script>
